import { render, staticRenderFns } from "./Itinerary.vue?vue&type=template&id=2662d5f2&"
import script from "./Itinerary.vue?vue&type=script&lang=js&"
export * from "./Itinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports